<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card>
        <v-card-text class="mt-5">
          <div id="show_description"></div>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn
            color="error"
            @click="$emit('close')"
            text
          >
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'

export default {
  name: "DescriptionDialog",
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      
    }
  },
  methods: {
    setDescription() {
      let div = document.getElementById("show_description");
      div.innerHTML = this.done_flow.flow_description_content;
    },
    ...mapActions({
      // function: 'Module/action'
    })
  },
  mounted () {
    this.setDescription();
  },
  computed: {
    ...mapState({
      done_flow: state => state.FlowExecution.done_flow
    })
  },
  watch: {
    
  },
}
</script>

<style scoped>

</style>
